import React, { useEffect, useState } from "react";
import moment from "moment";
import { useWebSocket } from "../../../context/WebSocketContext";
import "./GroupItem.css"; // Importing the external CSS file
import { Box } from '@mui/material'; 
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DataUnavailable from "../../../components/DataUnavailable";

type Props = {
  onClick: (groupInfo: GroupProps) => void;
};

export type GroupProps = {
  _id: string;
  profileIds: profileType[];
  groupName: string;
  groupType: string;
  updatedAt: string;
};
export type profileType = {
  _id?: string;
  countryCode: string;
  createdAt: string;
  firstName: string;
  idBack: string;
  idBackOriginalName: string;
  idBackkey: string;
  idFront: string;
  idFrontKey: string;
  idFrontOriginalName: string;
  lastName: string;
  phone: string;
  profilePic: string;
  profilePicKey: string;
  profilePicOriginalName: string;
  userId: {
    _id?: string;
    email: string;
    role: string;
  };
};

const GroupItem: React.FC<Props> = ({ onClick }) => {
  const { socket } = useWebSocket();
  const [isLoading, setIsLoading] = useState(false);
  // For tracking socket connection
  const [chatListData, setChatListData] = useState<GroupProps[]>([]);
  const [avatarErrors, setAvatarErrors] = useState<Record<string, boolean>>({});

  const getAvatarKey = (profile: profileType, index: number) =>
    profile?._id || profile?.userId?._id || `${profile?.firstName || "profile"}-${index}`;

  useEffect(() => {
    if (!socket) return;
    setIsLoading(true);
    socket.emit("get-chat-list");
    socket.on("chat-list", (data: any) => {
      setChatListData(data);
      setIsLoading(false);
    });

    return () => {
      socket && socket.off("chat-list");
    };
  }, [socket]);

  useEffect(() => {
    socket &&
      socket.on("group-created", (data: GroupProps) => {
        const updatedGroupChatList = [data, ...chatListData];
        setChatListData(updatedGroupChatList);
      });
    return () => {
      socket && socket.off("group-created");
    };
  }, [socket, chatListData]);

  return (


    <>
      {chatListData &&
        chatListData?.length > 0 ?
        chatListData.map((group: GroupProps, index) => {
          return (
            <Box
              onClick={() => onClick(group)}
              key={index}
              className="group-item"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 2,
                cursor: 'pointer',
              }}
            >
              <Box className="group-item-left" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box className="group-item-profile-pics" sx={{ display: 'flex' }}>
                  {group?.profileIds.length > 0 &&
                    group.profileIds
                      ?.slice(0, 4)
                      ?.map((profile: profileType, key) => {
                        const avatarKey = getAvatarKey(profile, key);
                        const isBroken = !profile.profilePic || avatarErrors[avatarKey];
                        return (
                          <React.Fragment key={key}>
                            {isBroken ? (
                              <Box
                                className={`group-item-profile-pic group-item-avatar-fallback ${
                                  key > 0 ? 'group-item-profile-pic-offset' : ''
                                }`}
                              >
                                <AccountCircleIcon className="group-item-avatar-icon" />
                              </Box>
                            ) : (
                              <img
                                className={`group-item-profile-pic ${
                                  key > 0 ? 'group-item-profile-pic-offset' : ''
                                }`}
                                src={profile.profilePic}
                                alt={profile.firstName}
                                onError={() =>
                                  setAvatarErrors((prev) => ({ ...prev, [avatarKey]: true }))
                                }
                              />
                            )}
                          </React.Fragment>
                        );
                      })}
                </Box>
                <Box className="group-item-info" sx={{ marginLeft: 2 }}>
                  <p className="group-item-group-name">{group.groupName}</p>
                  <p className="group-item-type">Group</p>
                </Box>
              </Box>
              <Box className="group-item-right" sx={{ textAlign: 'right' }}>
                <p className="group-item-time">
                  {moment(group.updatedAt).format('h:mm a')}
                </p>
                <p className="group-item-time">
                  {moment(group.updatedAt).fromNow()}
                </p>
              </Box>
            </Box>
          );
        })
        :
        <DataUnavailable description="No record found" />
      }
    </>
    
  );
};
export default GroupItem;
